// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
@media (max-width: 992px) {
  .slide-col .image-full-screen {
    display: none;
  }
}
@media (min-width: 991px) {
  .slide-col {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row-reverse;
  }
  .slide-col .image-full-screen {
    width: 55%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-col .image-full-screen .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-self: center;
    justify-content: center;
  }
  .slide-col .image-full-screen .image-wrapper .block-item {
    display: flex;
    align-self: center;
    justify-content: center;
    width: 100%;
    position: relative;
  }
  .slide-col .image-full-screen .image-wrapper .main-img {
    width: 50% !important;
    height: 50% !important;
  }
  .slide-col .image-full-screen .image-wrapper .main-img.is-own-bowl {
    width: 80% !important;
    height: 80% !important;
  }
  .slide-col .left-part-desktop {
    width: 45%;
    border-right: 1px solid var(--color-black);
  }
}
.slide-col.eintracht {
  color: #fff;
  background: #121212;
}

.back_btn_close {
  position: absolute;
  top: 10px;
  right: 15px;
  margin: 0px;
  background: transparent;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
}
.back_btn_close ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.back_btn_close:hover {
  background: #f2dbd9;
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  padding-bottom: 0px;
  align-items: center;
}
.header-wrapper .back_btn {
  width: 30px;
  height: 30px;
}
@media (min-width: 991px) {
  .header-wrapper .back_btn {
    display: none;
  }
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 10px;
  display: flex;
}
.option-group-col.hidden {
  max-height: 0px;
  display: none;
}

.last-item {
  height: 75px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  height: 35vh;
  position: relative;
}
@media (min-width: 991px) {
  .image-wrapper {
    display: none;
  }
}
.image-wrapper .category-background {
  position: absolute;
  z-index: 1;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100%;
  font-family: Title;
  font-size: 30vw;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .image-wrapper .category-background {
    width: 100%;
    font-size: 110px;
  }
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 15vh;
  width: 100%;
  margin: 0 auto 0px;
  z-index: 2;
}
@media (max-width: 992px) {
  .main-img {
    height: 33vh;
  }
}

.default-img {
  height: 15vh;
  width: 100px !important;
}

.info {
  padding: 0 20px;
}
.info .title {
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: left;
  vertical-align: middle;
  text-transform: uppercase;
  margin: 20px auto;
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
  margin-bottom: 4px;
}
.info .desc {
  font-family: AppFont;
  font-size: 12px;
  line-height: 130%;
  text-align: left;
  vertical-align: middle;
  margin-bottom: 25px;
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  margin-right: 0;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background-size: cover;
}

.button-footer-block {
  margin: 0px !important;
  background: #fff !important;
  padding: 20px 16px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-top: 1px solid #383838;
}
@media (min-width: 991px) {
  .button-footer-block {
    width: 45%;
    border-right: 1px solid var(--color-black);
  }
}
.button-footer-block .left-button {
  width: 48%;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
.button-footer-block .left-button.disabled {
  opacity: 0.5;
}
.button-footer-block .left-button h2,
.button-footer-block .left-button p {
  font-family: var(--ion-font-family);
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  vertical-align: middle;
  font-weight: 700;
  margin: 0 auto;
  text-box-trim: trim-end;
}
.button-footer-block .button-checkout {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 54%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-primary);
  border-radius: 26px;
}
@media (max-width: 992px) {
  .button-footer-block .button-checkout {
    width: 60%;
  }
}
.button-footer-block .button-checkout .left-price {
  background: #ecefec;
  height: 100%;
  border-radius: 26px;
  border: 1px solid #000000;
  padding: 0px 10px;
  position: relative;
}
.button-footer-block .button-checkout .left-price .option-total-quantity {
  position: absolute;
  top: -10px;
  right: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #000000;
  border-radius: 50px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.button-footer-block .button-checkout:hover {
  background: var(--ion-color-primary-tint);
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  font-size: 14px;
}
.button-footer-block .button-checkout .right-checkout {
  cursor: pointer;
  padding: 0px 15px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.button-footer-block .button-checkout .right-checkout p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}
.button-footer-block.eintracht {
  background: #121212 !important;
  border: none;
}

.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}
.show-option-groups {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.show-option-groups h1 {
  text-transform: uppercase;
  padding: 10px 20px;
}
.show-option-groups.error-item h1 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}
.show-option-groups ion-icon {
  transition: rotate 0.3s ease-in-out;
  margin-right: 20px;
  width: 15px;
  height: 15px;
}
.show-option-groups ion-icon.isOpen {
  rotate: 180deg;
}

.delete-option {
  position: absolute;
  bottom: -1px;
  right: 0%;
  z-index: 99;
  color: black;
  background: white;
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border-top: 2px dotted black;
  border-left: 2px dotted black;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

.input-notes {
  padding: 20px;
}
.input-notes ion-item {
  border-bottom: 1px dashed var(--ion-color-primary);
  --background: transparent;
  margin-bottom: 10px;
  margin-top: 0px;
  --padding-start: 0px;
}
.input-notes ion-item ion-input {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 90%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  font-family: AppFont;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-black);
}

.filters {
  width: 100%;
}
.filters app-menu-list-filters {
  width: 100%;
}

.text-block {
  margin-bottom: auto;
  margin-top: auto;
}

.price-row {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
}
.price-row .price {
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: right;
  vertical-align: middle;
  text-transform: uppercase;
  margin: 20px 0;
  margin-bottom: 0;
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

.opt-desc-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.opt-desc-row .option-group-limit {
  height: 100%;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  left: 4%;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.opt-desc-row .option-group-description {
  max-width: 37%;
  position: relative;
  font-size: 20px;
  line-height: 100%;
  vertical-align: middle;
  text-transform: uppercase;
}
.opt-desc-row .option-group-description::before, .opt-desc-row .option-group-description::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 50px;
  height: 2px;
  background: var(--color-black);
}
.opt-desc-row .option-group-description::before {
  transform: translate(-100%, 0px);
  left: 0%;
}
.opt-desc-row .option-group-description::after {
  transform: translate(100%, 0px);
  right: 0%;
}

ion-textarea.custom {
  --border-width: 0;
}

.info-block {
  border-top: 1px solid #DADADA;
  border-bottom: 1px solid #DADADA;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: auto;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  width: 30px;
  font-size: 20px !important;
}
.quantity-selector .quantity-btn {
  width: 16px;
  height: 16px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,kBAAA;AAFD;;AAMA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AAHD;ACNE;EDWA;IACC,aAAA;EAFD;AACF;ACjBE;EDQF;IAcE,aAAA;IACA,8BAAA;IACA,iBAAA;IACA,2BAAA;EADA;EAEA;IACC,UAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAAD;EACC;IACC,WAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,uBAAA;EACF;EAAE;IACC,aAAA;IACA,kBAAA;IACA,uBAAA;IACA,WAAA;IACA,kBAAA;EAEH;EACE;IACC,qBAAA;IACA,sBAAA;EACH;EAAG;IACC,qBAAA;IACA,sBAAA;EAEJ;EAGA;IACC,UAAA;IACA,0CAAA;EADD;AACF;AAGC;EACC,WAAA;EACA,mBAAA;AADF;;AAIA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AADD;AAEC;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAAF;AAEC;EACC,mBAAA;AAAF;;AAGA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAAD;AACC;EACC,WAAA;EACA,YAAA;AACF;AChGE;ED6FD;IAIE,aAAA;EAGD;AACF;;AAAA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAGD;AAFC;EACC,eAAA;EACA,aAAA;AAIF;;AADA;EACC,YAAA;AAID;;AADA;EACC,YAAA;EACA,cAAA;AAID;;AADA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AAID;;AAFA;EACC,YAAA;EAKA,kBAAA;AACD;ACtIE;ED+HF;IAGE,aAAA;EAQA;AACF;AAJC;EACC,kBAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMF;AC/JE;EDuID;IAqBE,WAAA;IACA,gBAAA;EAOD;AACF;AAJC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAMF;AAJC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAMF;;AAHA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAMD;ACpLE;ED0KF;IAOE,YAAA;EAOA;AACF;;AADA;EACC,YAAA;EACA,uBAAA;AAID;;AAFA;EACC,eAAA;AAKD;AAJC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;AAMF;AADE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAGH;AACC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACC;EACC,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACC,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AACH;AACE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AAAH;AClPE;EDyOA;IAWE,UAAA;IACA,iBAAA;EAEF;AACF;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AALD;AAAC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AAEF;;AAGA;EACC,kBAAA;AAAD;AAEC;EACC,6CAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;AAAF;AAEC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAIA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AADD;AAEC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAAF;AAEC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAAF;AAGC;EACC,YAAA;EACA,eAAA;AADF;;AAIA;EACC,sBAAA;EACA,uBAAA;AADD;;AAIA;EACC,sBAAA;AADD;;AAGA;EACC,uBAAA;AAAD;;AAEA;EACC,YAAA;EACA,WAAA;AACD;;AACA;EACC,YAAA;EACA,WAAA;AAED;AAEE;EANF;IAOG,YAAA;EACD;AACF;;AAEA;EACC,gBAAA;AACD;AAAC;EACC,WAAA;AAEF;;AACA;EACC,iBAAA;AAED;;AAAA;EACC,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAGD;;AADA;EAEC,sBAAA;AAGD;;AADA;EACC,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,6BAAA;AAID;ACvXE;EDsWF;IAeE,UAAA;IACA,0CAAA;EAMA;AACF;AAJC;EACC,UAAA;EACA,YAAA;EAIA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAGF;AAGE;EACC,YAAA;AADH;AAIE;;EAEC,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAFH;AAMC;EACC,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,mBAAA;AAJF;ACxZE;EDoZD;IAWE,UAAA;EAHD;AACF;AAIE;EACC,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAFH;AAIG;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAJJ;AAOE;EACC,yCAAA;AALH;AAOE;EACC,YAAA;AALH;AAOE;EACC,YAAA;AALH;AAOE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;AALH;AAQE;EACC,eAAA;EACA,0BAAA;EAYA,yBAAA;EACA,kBAAA;AAjBH;AAMG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AAJJ;AAUC;EACC,8BAAA;EACA,YAAA;AARF;;AAWA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AARD;;AAUA;EACC,YAAA;EACA,gBAAA;EACA,oBAAA;AAPD;;AAUA;EACC;IACC,+BAAA;EAPA;EASD;IACC,yBAAA;EAPA;EASD;IACC,+BAAA;EAPA;EASD;IACC,yBAAA;EAPA;AACF;AASA;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AAPD;AAQC;EACC,yBAAA;EACA,kBAAA;AANF;AASE;EACC,yBAAA;EACA,2CAAA;EACA,yBAAA;AAPH;AAUC;EACC,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AARF;AASE;EACC,cAAA;AAPH;;AAWA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;AARD;AASC;EACC,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;AAPF;;AAUA;EACC,aAAA;EACA,mBAAA;AAPD;AAQC;EACC,WAAA;EACA,YAAA;AANF;AAQC;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AANF;;AASA;EACC,aAAA;AAND;AAQC;EACC,kDAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AANF;AAOE;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AALH;AAQC;EACC,kBAAA;AANF;AAOE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,yBAAA;AANH;;AAUA;EACC,WAAA;AAPD;AAQC;EACC,WAAA;AANF;;AASA;EACC,mBAAA;EACA,gBAAA;AAND;;AAQA;EACC,aAAA;EACA,yBAAA;EACA,qBAAA;EACG,sBAAA;AALJ;AAOC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AALF;AAQC;EACC,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAPF;AASC;;EAEC,kBAAA;EACA,YAAA;EACA,iBAAA;AAPF;AAUC;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AARF;;AAYA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AATD;AAWC;EACC,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6BAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAXF;AAcC;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAZF;AAcE;EAEC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;AAbH;AAgBE;EACC,gCAAA;EAEA,QAAA;AAfH;AAiBE;EACC,+BAAA;EACA,SAAA;AAfH;;AAmBA;EACC,iBAAA;AAhBD;;AAkBA;EACC,6BAAA;EACA,gCAAA;AAfD;;AAiBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EAEA,YAAA;EAKA,YAAA;AAnBD;AAeC;EACC,eAAA;EACA,eAAA;AAbF;AAgBC;EACC,WAAA;EACA,0BAAA;AAdF;AAgBC;EACC,WAAA;EACA,YAAA;AAdF;AAeE;EACC,YAAA;AAbH","sourcesContent":["@import '../../../theme/mixins';\n\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n\t\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\t@include mobile {\n\t\t.image-full-screen {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: nowrap;\n\t\tflex-direction: row-reverse;\n\t\t.image-full-screen {\n\t\t\twidth: 55%;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t.image-wrapper {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-self: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t.block-item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-self: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\n\t\t\t\t.main-img {\n\t\t\t\t\twidth: 50% !important;\n\t\t\t\t\theight: 50% !important;\n\t\t\t\t\t&.is-own-bowl {\n\t\t\t\t\t\twidth: 80% !important;\n\t\t\t\t\t\theight: 80% !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.left-part-desktop {\n\t\t\twidth: 45%;\n\t\t\tborder-right: 1px solid var(--color-black);\n\t\t}\n\t}\n\t&.eintracht {\n\t\tcolor: #fff;\n\t\tbackground: #121212;\n\t}\n}\n.back_btn_close {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 15px;\n\tmargin: 0px;\n\tbackground: transparent;\n\twidth: 25px;\n\theight: 25px;\n\tpadding: 0px;\n\tz-index: 99;\n\tcursor: pointer;\n\tion-icon {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0px;\n\t}\n\t&:hover {\n\t\tbackground: #f2dbd9;\n\t}\n}\n.header-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\tpadding-bottom: 0px;\n\talign-items: center;\n\t.back_btn {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 10px;\n\tdisplay: flex;\n\t&.hidden {\n\t\tmax-height: 0px;\n\t\tdisplay: none;\n\t}\n}\n.last-item {\n\theight: 75px;\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-img {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 30px;\n}\n.image-wrapper {\n\theight: 35vh;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n\t// background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n\tposition: relative;\n\n\t.category-background {\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\tdisplay: block;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 100vw;\n\t\theight: 100%;\n\t\tfont-family: Title;\n\t\tfont-size: 30vw;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t@include desktop {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 110px;\n\t\t}\n\t}\n\n\t.back_icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 10px;\n\t\tz-index: 99;\n\t\tzoom: 1.5;\n\t}\n\t.cross_icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 10px;\n\t\tzoom: 1.5;\n\t}\n}\n.main-img {\n\theight: 15vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\tz-index: 2;\n\n\t@include mobile {\n\t\theight: 33vh;\n\t}\n\n\t// &.full-width {\n\t//   object-fit: cover;\n\t// }\n}\n.default-img {\n\theight: 15vh;\n\twidth: 100px !important;\n}\n.info {\n\tpadding: 0 20px;\n\t.title {\n\t\tfont-weight: 700;\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tmargin: 20px auto;\n\n\t\t// margin-bottom: 6px;\n\t\t// padding-top: 10px;\n\n\t\t.info_block {\n\t\t\tfont-size: 17px;\n\t\t\tmargin-left: 5px;\n\t\t\tcursor: pointer;\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\t}\n\n\t.desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 130%;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\tmargin-bottom: 25px;\n\t}\n\t.ingrediants-section {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 10px 0px;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\th3 {\n\t\t\ttext-align: left;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tp {\n\t\t\tcursor: pointer;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\t@include mobile {\n\t\t\t\twidth: 50%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.menge {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\th5 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\ttext-transform: uppercase;\n\t}\n\tmargin: 0px 20px 20px;\n}\n\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tfont-size: var(--modal-info-button-font-size);\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFont, sans-serif;\n\t\tmargin-right: 0;\n\t}\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n\nion-toolbar {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\t--background: var(--background-color);\n\tion-title {\n\t\tfont-weight: 100;\n\t\tpadding-inline: unset !important;\n\t\tfont-size: 16px;\n\t\ttext-align: left;\n\t\tmargin-left: 40px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\tpadding: 8px;\n\t\tfont-size: 15px;\n\t}\n}\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\nion-page {\n\tbackground: transparent;\n}\n.slider-select-half {\n\theight: 100%;\n\twidth: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n\tmargin: 5px 20px;\n\tapp-accordion-list {\n\t\twidth: 100%;\n\t}\n}\n.padding-block {\n\tpadding: 0px 20px;\n}\n.vertical-line {\n\tcontent: ' ';\n\twidth: 1px;\n\theight: 20px;\n\tcolor: white;\n\tbackground: white;\n\tmargin-inline: 10px;\n}\n.add-background {\n\t// background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n.button-footer-block {\n\tmargin: 0px !important;\n\tbackground: #fff !important;\n\tpadding: 20px 16px;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tz-index: 999;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tfont-size: 14px;\n\tborder-top: 1px solid #383838;\n\t@include desktop {\n\t\twidth: 45%;\n\t\tborder-right: 1px solid var(--color-black);\n\t}\n\n\t.left-button {\n\t\twidth: 48%;\n\t\theight: 40px;\n\t\t// background: transparent;\n\t\t// border-radius: 26px;\n\t\t// border: 1px solid #000000;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 0;\n\n\t\t// @include mobile {\n\t\t// \twidth: 40%;\n\t\t// }\n\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\n\t\th2,\n\t\tp {\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 130%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\tfont-weight: 700;\n\t\t\tmargin: 0 auto;\n\t\t\ttext-box-trim: trim-end;\n\t\t}\n\t}\n\n\t.button-checkout {\n\t\twidth: fit-content;\n\t\tmax-width: 54%;\n\t\theight: 40px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder-radius: 26px;\n\n\t\t@include mobile {\n\t\t\twidth: 60%;\n\t\t}\n\t\t.left-price {\n\t\t\tbackground: #ecefec;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 26px;\n\t\t\tborder: 1px solid #000000;\n\t\t\tpadding: 0px 10px;\n\t\t\tposition: relative;\n\n\t\t\t.option-total-quantity {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -10px;\n\t\t\t\tright: 0;\n\t\t\t\theight: 20px;\n\t\t\t\twidth: 20px;\n\t\t\t\tborder: 1px solid #000000;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tbackground: #fff;\n\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tletter-spacing: 0.08em;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: var(--ion-color-primary-tint);\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 2%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 14px;\n\t\t}\n\n\t\t.right-checkout {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 0px 15px 0px 10px;\n\n\t\t\tp {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 120%;\n\t\t\t\tletter-spacing: 2%;\n\t\t\t\ttext-align: center;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\t&.eintracht {\n\t\tbackground: #121212!important;\n\t\tborder: none;\n\t}\n}\n.center-element {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding-bottom: 80px;\n}\n\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: var(--color-black);\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t100% {\n\t\tcolor: var(--color-black);\n\t}\n}\n.show-option-groups {\n\tdisplay: flex;\n\tcursor: pointer;\n\talign-items: center;\n\tjustify-content: space-between;\n\th1 {\n\t\ttext-transform: uppercase;\n\t\tpadding: 10px 20px;\n\t}\n\t&.error-item {\n\t\th1 {\n\t\t\tcolor: var(--color-black);\n\t\t\tanimation: pulseColor 4s infinite alternate;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\tion-icon {\n\t\ttransition: rotate 0.3s ease-in-out;\n\t\tmargin-right: 20px;\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\t&.isOpen {\n\t\t\trotate: 180deg;\n\t\t}\n\t}\n}\n.delete-option {\n\tposition: absolute;\n\tbottom: -1px;\n\tright: 0%;\n\tz-index: 99;\n\tcolor: black;\n\tbackground: white;\n\tborder-top-left-radius: 15px;\n\ttext-align: center;\n\tpadding: 7px;\n\tborder-top: 2px dotted black;\n\tborder-left: 2px dotted black;\n\tp {\n\t\tfont-size: 13px;\n\t\tfont-family: 'AppFontBold';\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.vegan-block {\n\tdisplay: flex;\n\talign-items: center;\n\tion-img {\n\t\twidth: 35px;\n\t\theight: 24px;\n\t}\n\tp {\n\t\ttext-transform: capitalize;\n\t\tmargin-right: 5px;\n\t\tfont-size: 12px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n.input-notes {\n\tpadding: 20px;\n\t// border-top: 1px solid var(--color-black);\n\tion-item {\n\t\tborder-bottom: 1px dashed var(--ion-color-primary);\n\t\t--background: transparent;\n\t\tmargin-bottom: 10px;\n\t\tmargin-top: 0px;\n\t\t--padding-start: 0px;\n\t\tion-input {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t.container {\n\t\tposition: relative;\n\t\tion-label {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 11px;\n\t\t\tline-height: 85%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n.filters {\n\twidth: 100%;\n\tapp-menu-list-filters {\n\t\twidth: 100%;\n\t}\n}\n.text-block {\n\tmargin-bottom: auto;\n\tmargin-top: auto;\n}\n.price-row {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: flex-end;\n    flex-direction: column;\n\n\t.price {\n\t\tfont-weight: 700;\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\ttext-align: right;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tmargin: 20px 0;\n\t\tmargin-bottom: 0;\n\t}\n\n\t.kcall {\n\t\tposition: relative;\n\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\t.kcall,\n\t.tags {\n\t\tposition: relative;\n\t\theight: 17px;\n\t\tmargin-left: 12px;\n\t}\n\n\t.kcall::before,\n\t.tags::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: -6px;\n\t\twidth: 1.5px;\n\t\theight: 100%;\n\t\tbackground: var(--color-black);\n\t}\n}\n\n.opt-desc-row {\n\tposition: relative;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\n\t.option-group-limit {\n\t\theight: 100%;\n\t\twidth: fit-content;\n\t\tposition: absolute;\n\t\tleft: 4%;\n\t\ttop: 50%;\n\t\ttransform: translate(0, -50%);\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.option-group-description {\n\t\tmax-width: 37%;\n\t\tposition: relative;\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\twidth: 50px;\n\t\t\theight: 2px;\n\t\t\tbackground: var(--color-black);\n\t\t}\n\n\t\t&::before {\n\t\t\ttransform: translate(-100%, 0px);\n\n\t\t\tleft: 0%;\n\t\t}\n\t\t&::after {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\tright: 0%;\n\t\t}\n\t}\n}\nion-textarea.custom {\n\t--border-width: 0;\n}\n.info-block {\n\tborder-top: 1px solid #DADADA;\n\tborder-bottom: 1px solid #DADADA;\n}\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: fit-content;\n\n\tmargin: auto;\n\tion-icon {\n\t\tmargin: 0px 6px;\n\t\tcursor: pointer;\n\t}\n\tz-index: 999;\n\t.quantity {\n\t\twidth: 30px;\n\t\tfont-size: 20px!important;\n\t}\n\t.quantity-btn {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
